import { Circle } from "lucide-react";
import { cn } from "../lib/utils";

function normalized(value?: string) {
  return value?.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase() ?? "";
}

export function StatusBadge({
  status,
  compact = false,
}: {
  status?: string;
  compact?: boolean;
}) {
  const value = normalized(status);
  const tone =
    value.includes("final") || value.includes("resol")
      ? "success"
      : value.includes("aguard")
        ? "warning"
        : value.includes("cancel")
          ? "neutral"
          : "info";

  return (
    <span className={cn("status-badge", `status-badge--${tone}`)}>
      <Circle className="size-2 fill-current" />
      {compact ? status || "Novo" : status || "Aguardando atendimento"}
    </span>
  );
}

export function PriorityBadge({ priority }: { priority?: string }) {
  const value = normalized(priority);
  const tone = value.includes("alta") || value.includes("altiss")
    ? "high"
    : value.includes("media")
      ? "medium"
      : "low";

  return (
    <span className={cn("priority-badge", `priority-badge--${tone}`)}>
      <span />
      {priority || "Baixa"}
    </span>
  );
}
